import React from 'react';
import PropTypes from 'prop-types';
import QueuedSamples from './QueuedSamples';
import { filterCurrentRuns, nSamplesInRuns } from '../utils';

const stylesTable = {
  borderCollapse: 'collapse',
  borderSpacing: 0
};

function NextSeqPacBioRunsQueuedTable(props) {
  const currentRuns = filterCurrentRuns(props.runs, false);
  const nNextSeqSamples = nSamplesInRuns(currentRuns, 'NextSeq');
  const nPacBioSamples = nSamplesInRuns(currentRuns, 'PacBio');
  return (
    <table className="queueT" style={stylesTable}>
      <tbody>
        <tr>
          <th colSpan={7}>
            Queued for <span style={{ color: 'red' }}>NextSeq</span>&nbsp;({nNextSeqSamples})
            &amp; <span style={{ color: 'red' }}>PacBio</span>&nbsp;({nPacBioSamples})
          </th>
        </tr>
        <tr>
          <th></th>
          <th>Run</th>
          <th>Target</th>
          <th>#</th>
          <th>Libr.</th>
          <th>Seq.</th>
          <th>Anal.</th>
        </tr>
        {props.runs.map(run => (
          <QueuedSamples
            key={'sg' + run.run_id}
            runId={run.run_id}
            sampleGroups={run.samples} />
        ))}
      </tbody>
    </table>
  );
}

NextSeqPacBioRunsQueuedTable.propTypes = {
  platformName: PropTypes.string.isRequired,
  runs: PropTypes.array.isRequired
};

export default NextSeqPacBioRunsQueuedTable;
